import { FlaskConical } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ICompany } from '@/types/company';

export const CompanyAvatar = ({
  company,
  className,
}: {
  company: ICompany;
  className?: string;
}) => {
  const initials = company.name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-md text-xs font-bold shrink-0',
        company.isDemo
          ? 'bg-secondary text-secondary-accent'
          : 'bg-secondary-accent text-white',
        className,
      )}
    >
      {company.isDemo ? <FlaskConical className="size-3.5" /> : initials}
    </div>
  );
};
